import highchartsBasics from '@/language/es/mixins/highcharts-basics';
import exportModel from '@/language/es/mixins/export-model';
import pagesModel from '@/language/es/mixins/pages-model';
import formModel from '@/language/es/mixins/form-model';
import genderModel from '@/language/es/mixins/gender-model';
import cardsModel from '@/language/es/mixins/cards-model';
import statusModel from '@/language/es/mixins/status-model';
import filtersModel from '@/language/es/mixins/filters-model';
import sentimentModel from '@/language/es/mixins/sentiment-model';
import deviceModel from '@/language/es/mixins/device-model';
import channelModel from '@/language/es/mixins/channel-model';
import sacTypeModel from '@/language/es/mixins/sac-type-model';

export default {
  highchartsBasics,
  exportModel,
  pagesModel,
  formModel,
  genderModel,
  cardsModel,
  statusModel,
  filtersModel,
  sentimentModel,
  deviceModel,
  channelModel,
  sacTypeModel,
};
